import LinkButton from '@core/components/linkbutton/LinkButton';

import ExpiredImage from 'assets/images/expired-job-post.svg';

import classes from 'styles/notfound.module.scss';

const Gone = () => {
	return (
		<section className={`${classes['not-found-container']} container mb-3 my-md-5 my-xl-5`}>
			<ExpiredImage />
			<h1>This page is no longer available</h1>
			<p>
				The page you are looking for has been permanently removed and is no longer available.
			</p>
			<LinkButton className={classes['action']} kind="primary-color" to="/">
				Go to Homepage
			</LinkButton>
		</section>
	);
};

export default Gone;
